import { Reducer } from "redux";

export interface CampaignState {
  Name?: string;
  Description?: string;
  Addons?: string[];
}

type CampaignStateType = CampaignState | null | undefined;
const defaults: CampaignStateType = null;

export const reducer: Reducer<CampaignStateType> = (state: CampaignStateType = defaults): CampaignStateType => {
  return state;
};

export const actions = {};
